import React from 'react';
import Accordion from "@scentregroup/ui/components/accordion";
import Pill from "@scentregroup/ui/components/pill";
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FiltersSmall = _ref => {
  let {
    children,
    countDisplay,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(Accordion, {
    headerElement: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        "data-id": "whats-happening-filters_filters-small_FiltersSmall_span",
        children: "Filters"
      }), /*#__PURE__*/_jsx(Pill, {
        className: styles.accordionCount,
        type: "primary",
        dataTestId: "whats-happening-items-count-small",
        "data-id": "whats-happening-filters_filters-small_FiltersSmall_Pill",
        children: countDisplay
      })]
    }),
    type: "small",
    classNames: styles,
    id: "whats-happening-filters",
    onClick: onClick,
    "data-id": "whats-happening-filters_filters-small_FiltersSmall_Accordion",
    children: children
  });
};
export default FiltersSmall;